export default __webpack_public_path__ + "static/media/home-bg.7f6133a0.png";